import React, { useState, useEffect } from "react";
import BASE_URL from "components/BaseUrl/apiConfig";

export default function AllTimeMsg() {
  const [data, setData] = useState([]);

  const storedUserData = localStorage.getItem("userData");
  let groupId = "";

  if (storedUserData) {
    const userData = JSON.parse(storedUserData);
    groupId = userData.groupId;
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${BASE_URL}/api/Analytics/GetAllTimeMsg?groupId=${groupId}`
        );
        const result = await response.json();
        setData(result);
        console.log(result);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [groupId]);

  return (
    <>
      <div className="container mx-auto p-4">
        <div className="flex justify-between items-center mb-4 flex-wrap">
          <h1 className="text-2xl  font-bold">Marketing Dashboard</h1>
        </div>
      </div>
    </>
  );
}
